import { Box } from '@mui/material';
import { useCallback } from 'react';

import { EmployeeProposalsTabs } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog';

import {
  AllowanceProposalHistoryTable,
  BenefitProposalHistoryTable,
  SalaryProposalHistoryTable,
} from './components/ProposalsHistoryTables';

type PropsType = {
  activeTab?: EmployeeProposalsTabs | false;
};

export const EmployeeProposalsHistory = (props: PropsType) => {
  const { activeTab } = props;

  const renderTab = useCallback((tab: EmployeeProposalsTabs) => {
    switch (tab) {
      case EmployeeProposalsTabs.SalaryProposal:
        return <SalaryProposalHistoryTable />;
      case EmployeeProposalsTabs.BenefitProposal:
        return <BenefitProposalHistoryTable />;
      case EmployeeProposalsTabs.AllowanceProposal:
        return <AllowanceProposalHistoryTable />;
      default:
        return <SalaryProposalHistoryTable />;
    }
  }, []);

  return <Box>{!!activeTab && renderTab(activeTab)}</Box>;
};
